import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userReducer";
import notificationReducer from "./notificationReducer";
import pgaFormReducer from "./pgaFormReducer";
import reportReducer from "./reportReducer";
import farmerAccountReducer from "./farmerAccountReducer";
import dataManagementReducer from "./dataManagementReducer";
import historyQueryReducer from "./historyQueryReducer";
import pricingManagementReducer from"./pricingManagementReducer";

export default configureStore({
  reducer: {
    user: userReducer,
    notification: notificationReducer,
    pgaForm: pgaFormReducer,
    report: reportReducer,
    farmerAccount: farmerAccountReducer,
    dataManagement: dataManagementReducer,
    historyQuery: historyQueryReducer,
    pricingManagementReducer: pricingManagementReducer
  },
});
